export const enumeratedVlans = (port: { usedVlans: string[] }): number[] => port.usedVlans.flatMap(enumerateVlanString);

export const enumerateVlanString = (vlanString: string): number[] =>
  vlanString.split(",").flatMap((s) => {
    const n = Number(s);
    if (!isNaN(n)) return [n];
    const [start, end] = s.split("-").map(Number);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  });

export const isValidVlan = (port: { usedVlans: string[] }, input: string): boolean => {
  const usedVlans = new Set(enumeratedVlans(port));
  return !enumerateVlanString(input).some((v) => usedVlans.has(v));
};
